import React from 'react';

const context = React.createContext({
  state: {},
  config: {},
});

export default context;
